var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"404 full-page-width relative"},[_c('h1',{staticClass:"info"},[_vm._v(_vm._s(_vm.$t('page_not_found')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }